import { loadEconomy } from '@runkr/config/economy'
import type { Economy } from '@runkr/config/economy'
import type { ResultRow } from '../../net/roomSnapshot'
import type { RewardSource } from './rewardRows'

/** One line of the Times list (place, name, time or DNF). */
export interface TimeRow {
  index: number
  placement: number
  name: string
  finished: boolean
  finishMs: number
  isMe: boolean
}

/** What a finished practice race hands the podium screen (no server, nothing saved). */
export interface PracticeResult {
  times: TimeRow[]
  me: RewardSource
}

/** The Times list from the room's results, by placement. */
export function timeRows(results: readonly ResultRow[], mySessionId: string): TimeRow[] {
  return [...results]
    .sort((a, b) => a.placement - b.placement)
    .map((r) => ({
      index: r.index,
      placement: r.placement,
      name: r.displayName,
      finished: r.finished,
      finishMs: r.finishMs,
      isMe: r.sessionId === mySessionId,
    }))
}

let cached: Economy | null = null

/** `economy.json` (validated once), for computing rewards the server did not send. */
export function economy(): Economy {
  cached ??= loadEconomy()
  return cached
}
